<template>
  <div class="latest_news">
    <div class="gotit_block_top">
      <div class="gotit_block_title">Latest News</div>
      <div class="gotit_block_more" @click.stop="seeAllNews()">See All</div>
    </div>
    <div v-for="neww of latesNews" :key="neww.id" class="ln_grid">
      <img @click="showUser(neww)" class="ln_grid_img pointer" v-lazy-load :data-src="getUser(neww.initiatorId).profilePhotoThumbnail || getUser(neww.initiatorId).image"/>
      <div class="new_content">
        <div>
          <span class="username pointer" @click="showUser(neww)">{{ getUser(neww.initiatorId).name }} </span>
          <span class="action pointer" @click="onNewsClick(neww)">{{ types[typesKeys[neww.type]] }}</span>
          <!-- BOBO item not available on news APIU <span class="store">{{ getUser(getItem(itemId).userId).name }}</span> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import utils from '~/mixins/utils'

export default {
  name: 'LatestNews',
  mixins: [utils],
  mounted () {
    this.typesKeys = Object.keys(this.types)
    if (this.$store.state.localStorage.currentUser && this.$store.state.localStorage.currentUser.id > 0) {
      this.$store.dispatch('api/selectNews', {
        filter: 'USER_ALL',
        limit: 3,
        cache: true
      }).then((data) => {
        this.latesNews = data
      })
    }
  },
  data () {
    return {
      types: {
        NONE: 'Welcome to GOTit\nHere you will find news from people\nand stores that you follow',
        LIKE: 'Liked your items',
        FOLLOW: 'Started following you',
        COMMENT: 'Commented on your items',
        OFFER: 'Made you an offer',
        WANT_IT: 'Wants your items',
        GOT_IT: 'Got your items',
        GIFT_IT: 'Gifted you with an items',
        QUANTITY: 'Your GIT for the items reached its minimum quantity',
        COMMIT_TO_BUY: 'Has committed to buy your items',
        STORE_GIT: 'Openned GETit TOGETHER for your items',
        FACEBOOK: 'Your Facebook friend has joined GOTit',
        GROUP_MESSAGE: 'You have a new group message',
        SALE_IT: 'An items you want is on sale',
        ITEM_KING: 'You are this items king',
        OFFER_COMMENT: 'Commented on your offer',
        USERNAME_MENTIONED_IN_COMMENT: 'Mentioned you in a comment',
        SHARED_ITEM_AT_STORE_LOCATION: 'Shared an items with your location',
        GIFT_IT_REQUEST: 'Sent you a GIFTit Request',
        GIFT_IT_CONFIRMATION: 'Confirmed your GIFTit request',
        GIFT_IT_COMMENT: 'Commented on a GIFTit Request',
        GIFT_IT_REJECT: 'Rejected your GIFTit request',
        ORDER_PAID: 'GOTit with PayPal',
        ORDER_ACCEPTED: 'Confirmed your order',
        ORDER_REJECTED: 'Rejected your order',
        ORDER_COMMENT: 'Commented on your order',
        ORDER_DELIVERED: 'Shipped your order',
        ORDER_CONFIRMED: 'Confirmed delivery',
        LEFT_FEEDBACK: 'Left you a feedback',
        NEW_ORDER_CREATED: 'View your new order',
        PAYPAL_PAYMENT_FAILED: 'Payment failed',
        OPEN_EXPLORE: 'Explore GOTit',
        OPEN_EXPLORE_DEALS: 'Check out our special deals!',
        OPEN_ITEM: 'Item of the day!',
        OPEN_USER: 'Store of the day!',
        OPEN_CATEGORY: 'Category of the day!',
        PRIVATE_MESSAGE: 'Sent you a private message',
        AUTO_OFFER: 'Your price offer was accepted',
        FEEDBACK_REMINDER: 'Leave feedback reminder',
        REQUEST_RETURN: 'sent you a return request',
        RETURN_ACCEPTED: 'accepted your return request',
        RETURN_REJECTED: 'rejected your return request',
        ITEM_RETURNED: 'Item returned to the stores',
        REFUNDED: 'Order refunded',
        SENT_CREDIT: 'Sent you CREDit',
        CREDIT_CARD_PAYED: 'GOTit with credit card',
        CREDIT_EXPIRING: 'Your credit is expiring in %d days. Enjoy it while it lasts',
        ITEM_RESTOCKED: 'An items you want is restocked!',
        CART_CHECKOUT: 'New orders were created',
        SUBSCRIPTION_CREATED: 'Your subscription order was created',
        SUBSCRIPTION_ORDER_CREATED: 'You have a new subscription package order',
        SUBSCRIPTION_CANCELED: 'Your subscription has been cancelled',
        SUBSCRIPTION_FAILED: 'Your subscription payment failed',
        NEWS_SOCIAL_CREDIT_JOINED: 'Just joined GOTit, You got $@ credit!',
        NEWS_SOCIAL_CREDIT_PURCHASED: 'Got his 1st items, You got $@ credit!',
        NEWS_DISPUTE_MESSAGE: 'Commented on your order'
      },
      typesKeys: [],
      news: [],
      latesNews: []
    }
  },
  methods: {
    seeAllNews () {
      this.$root.$emit('seeAllNews')
    },
    onNewsClick (newEntity) {
      switch (this.typesKeys[newEntity.type]) {
        case 'CART_CHECKOUT':
          this.$router.push({
            path: '/orders'
          })
          break
        case 'PRIVATE_MESSAGE':
          this.$router.push({
            path: '/comments'
          })
          break
        case 'SALE_IT':
          this.addItemDetailsToEventsLayer('select_item', newEntity.itemId)
          this.$router.push({
            path: '/items/' + this.encrypt(newEntity.itemId)
          })
          break
        case 'NEWS_SOCIAL_CREDIT_PURCHASED':
        case 'NEWS_SOCIAL_CREDIT_JOINED':
        case 'SENT_CREDIT':
          this.$router.push({
            path: '/offers'
          })
          break
        case 'WANT_IT':
          if (newEntity.initiatorId) {
            this.$router.push({
              path: '/users/' + newEntity.initiatorId
            })
          } else if (newEntity.itemId) {
            this.addItemDetailsToEventsLayer('select_item', newEntity.itemId)
            this.$router.push({
              path: '/items/' + this.encrypt(newEntity.itemId)
            })
          }
          break
        case 'ORDER_ACCEPTED':
        case 'ORDER_REJECTED':
        case 'ORDER_COMMENT':
        case 'ORDER_DELIVERED':
        case 'ORDER_CONFIRMED':
          this.$router.push({
            path: '/orders/' + this.encrypt(newEntity.orderId)
          })
          break
        default:
          console.log(this.typesKeys[newEntity.type])
          break
      }
      this.setHasSeend(newEntity)
    },
    setHasSeend (newEntity) {
      newEntity.hasSeen = true
      // eslint-disable-next-line no-unused-vars
      this.$store.dispatch('api/updateNew', newEntity).then().catch()
    },
    showUser (neww) {
      const user = this.getUser(neww.initiatorId)
      if (user.store) {
        this.$router.push({
          path: '/stores/' + this.encrypt(user.id)
        })
      } else {
        this.$router.push({
          path: '/users/' + this.encrypt(user.id)
        })
      }
      this.setHasSeend(neww)
    },
    getUser (userId) {
      return this.$store.state.api.buckets.users[userId]
    },
    getOrder (orderId) {
      return this.$store.state.api.buckets.orders[orderId]
    },
    getItem (userId) {
      return this.$store.state.api.buckets.items[userId]
    },
    onItemClick (neww, item, $event) {
      this.addItemDetailsToEventsLayer('select_item', item.id)
      this.$router.push({
        path: '/items/' + this.encrypt(item.id)
      })
      this.setHasSeend(neww)
      $event.stopPropagation()
    },
    getDiff (date) {
      const date1 = new Date(date)
      const currentDate = new Date()
      const diffDays = parseInt((currentDate - date1) / (1000 * 60 * 60 * 24), 10)
      if (diffDays < 7) {
        return diffDays + 'd'
      } else {
        return parseInt(diffDays / 7) + 'w'
      }
    }
  }
}
</script>
<style scoped>

  .latest_news > h3 {
    margin-bottom: 1em;
  }
  .latest_news {
    margin-top: 2em;
    margin-bottom: 1em;
  }

  .ln_grid, .new_content {
    display: flex;
    align-items: center;
    justify-content: start;
    flex-basis: 246px;
    flex-grow: 0;
    flex-shrink: 0;
    margin-bottom: 5px;
  }

  .ln_grid_img {
    width: 39px !important;
    height: 39px !important;
    margin-right: 15px;
  }

  .username {
    font-family: 'Arial Bold', 'Arial', serif;
    font-weight: 700;
  }

  .store {
    font-family: 'Arial', serif;
    font-weight: 400;
  }

  .new_content > div {
    /*padding-left: 15px;*/
    width: 190px
  }
</style>
